import React, { useState, useEffect, useRef } from 'react';
import MyInput from './Input';
import { CameraOutlined, CloseOutlined, LoadingOutlined, PlusOutlined } from '@ant-design/icons';
import { Avatar, Divider, message, Modal, Select, Upload } from 'antd';
import { RcFile, UploadProps } from 'antd/es/upload';
import { UploadFile } from 'antd/es/upload/interface';
import Typography from './Typography';
import { COLORS } from '../constants/Colors';
import DefaultProfile from '../../src/assets/Profile_Default.png';
import Resizer from 'react-image-file-resizer';
import _ from 'lodash';
import { FormattedMessage, useIntl } from 'react-intl';
import { Option } from 'antd/es/mentions';

const RegisterForm = ({
  setProfilePic,
  setProfileDoc,
  setPhoneCom,
  phoneCom,
  setName,
  name,
  customerType,
  selectCustomerType,
  setSelectCustomerType,
  setTaxNo,
  taxNo,
  setAddress,
  address,
  setContact,
  contact,
  setPhone,
  phone,
  setEmail,
  email,
  setErrorValidate,
  errorValidate,
  setIsCheck,
  isCheck,
  errorValidateType,
  setErrorValidateType,
}) => {
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState('');
  const [previewTitle, setPreviewTitle] = useState('');
  const [isJpgOrPng, setIsJpgOrPng] = useState(true);
  const [fileList, setFileList] = useState([]);
  const [previewOpenDoc, setPreviewOpenDoc] = useState(false);
  const [previewImageDoc, setPreviewImageDoc] = useState('');
  const [previewTitleDoc, setPreviewTitleDoc] = useState('');
  const [fileListDoc, setFileListDoc] = useState([]);
  const [isPdf, setIsPdf] = useState(true);
  const [imageFileDefault, setImageFileDefault] = useState('');
  const imageRef = useRef();
  const intl = useIntl();

  const fileTypesImg = '.jpg,.png';
  const fileTypesWord = '.pdf,.doc,.docx';

  const uploadButton = (
    <div>
      <PlusOutlined />
      <div style={{ marginTop: 8 }}>Upload</div>
    </div>
  );

  const beforeUpload = (file) => {
    const checkIsJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
    if (!checkIsJpgOrPng) {
      setIsJpgOrPng(false);
      message.error('You can only upload JPG/PNG file!');
      setPreviewImage('');
      setPreviewTitle('');
    } else {
      setIsJpgOrPng(true);
    }
    // const isLt2M = file.size / 1024 / 1024 < 2;
    // if (!isLt2M) {
    //   message.error("Image must smaller than 2MB!");
    // }
    // return isJpgOrPng && isLt2M;
    return isJpgOrPng;
  };

  const handleCancel = () => setPreviewOpen(false);

  const handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }

    setPreviewImage(file.url || file.preview);
    setPreviewOpen(true);
    setPreviewTitle(file.name || file.url.substring(file.url.lastIndexOf('/') + 1));
  };
  const resizeImage = (img, maxSizeKB) => {
    return new Promise((resolve, reject) => {
      const imgQuality = 0.8; // You can adjust the image quality if needed
      const reader = new FileReader();

      reader.onload = (event) => {
        const imgDataUrl = event.target.result;
        const imgElement = new Image();

        imgElement.onload = () => {
          const canvas = document.createElement('canvas');
          const aspectRatio = imgElement.width / imgElement.height;
          let newWidth = Math.sqrt(maxSizeKB * 1024 * aspectRatio);
          let newHeight = newWidth / aspectRatio;

          if (newWidth > imgElement.width) {
            newWidth = imgElement.width;
            newHeight = imgElement.height;
          }

          canvas.width = newWidth;
          canvas.height = newHeight;

          const ctx = canvas.getContext('2d');
          ctx.drawImage(imgElement, 0, 0, newWidth, newHeight);

          canvas.toBlob(
            (blob) => {
              const resizedFile = new File([blob], img.name, {
                type: 'image/jpeg', // Change the type as needed (jpeg, png, etc.)
                lastModified: Date.now(),
              });
              resolve(resizedFile);
            },
            'image/jpeg',
            imgQuality
          );
        };

        imgElement.onerror = (error) => {
          reject(error);
        };

        imgElement.src = imgDataUrl;
      };

      reader.onerror = (error) => {
        reject(error);
      };

      reader.readAsDataURL(img);
    });
  };

  // const handleChange: UploadProps["onChange"] = async ({ fileList: newFileList }) => {
  //   const resizedImage = await resizeImage(newFileList[0].originFileObj, 2000);

  //   if (newFileList[0].size > 2000000) {
  //     if (newFileList.length > 0 && isJpgOrPng) {
  //       setProfilePic(resizedImage);
  //       setFileList(newFileList[0]);
  //       setFileList((e) => [{ ...e, status: "done" }]);
  //     } else {
  //       setProfilePic("");
  //       setFileList([]);
  //     }
  //   } else {
  //     if (newFileList.length > 0 && isJpgOrPng) {
  //       setProfilePic(newFileList[0].originFileObj);
  //       setFileList(newFileList[0]);
  //       setFileList((e) => [{ ...e, status: "done" }]);
  //     } else {
  //       setProfilePic("");
  //       setFileList([]);
  //     }
  //   }
  // };

  const getBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });

  const beforeUploadDoc = (file) => {
    const checkIsPdf = file.type === 'application/pdf';
    if (!checkIsPdf) {
      setIsPdf(false);
      message.error('You can only upload PDF file!');
      setPreviewImageDoc('');
      setPreviewTitleDoc('');
    } else {
      setIsPdf(true);
    }
    // const isLt2M = file.size / 1024 / 1024 < 2;
    // if (!isLt2M) {
    //   message.error("Image must smaller than 2MB!");
    // }
    // return isJpgOrPng && isLt2M;
    return isPdf;
  };

  const handleCancelDoc = () => setPreviewOpenDoc(false);

  const handlePreviewDoc = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64Doc(file.originFileObj);
    }

    setPreviewImageDoc(file.url || file.preview);
    setPreviewOpenDoc(true);
    setPreviewTitleDoc(file.name || file.url.substring(file.url.lastIndexOf('/') + 1));
  };
  const handleChangeDoc = async (info) => {
    const newFileList = [...info.fileList];
    const processedImages = [];
    const processedImagesFile = [];

    for (const file of newFileList) {
      try {
        const resizedImage = await resizeImage(file.originFileObj, 2000); // Resize image to less than 500 kB
        getBase64Doc(resizedImage, (url) => {
          processedImages.push({
            imageCustomerDoc: resizedImage,
            imageUrl: url,
          });
          processedImagesFile.push({
            uid: file.uid,
            name: 'image.png',
            status: 'done',
            url: url,
          });

          if (processedImages.length === newFileList.length) {
            setProfileDoc(processedImages);
            setFileListDoc(processedImagesFile);
            //console.log('fileListDoc', processedImagesFile);
          }
        });
      } catch (error) {
        console.error('Error resizing image:', error);
      }
    }
  };

  // const handleChangeDoc: UploadProps["onChange"] = async ({
  //   fileList: newFileList,
  // }) => {
  //   const resizedImage = await resizeImage(newFileList[0].originFileObj, 2000);

  //   if (newFileList[0].size > 2000000) {
  //     if (newFileList.length > 0 && isJpgOrPng) {
  //       setProfileDoc(resizedImage);
  //       setFileListDoc(newFileList[0]);
  //       setFileListDoc((e) => [{ ...e, status: "done" }]);
  //     } else {
  //       setFileListDoc([]);
  //       setProfileDoc([]);
  //     }
  //   } else {
  //     if (newFileList.length > 0 && isJpgOrPng) {
  //       setProfileDoc(newFileList[0].originFileObj);
  //       setFileListDoc(newFileList[0]);
  //       setFileListDoc((e) => [{ ...e, status: "done" }]);
  //     } else {
  //       setFileListDoc([]);
  //       setProfileDoc([]);
  //     }
  //   }
  // };
  const getBase64Doc = (img, callback) => {
    const reader = new FileReader();
    reader.addEventListener('load', () => callback(reader.result));
    reader.readAsDataURL(img);
  };

  // const getBase64Doc = (file) =>
  //   new Promise((resolve, reject) => {
  //     const reader = new FileReader();
  //     //console.log("getBase64 file: ", file);
  //     reader.readAsDataURL(file);
  //     reader.onload = () => resolve(reader.result);
  //     reader.onerror = (error) => reject(error);
  //   });

  const uploadButtonDoc = (
    <div>
      <PlusOutlined />
      <div style={{ marginTop: 8 }}>Upload</div>
    </div>
  );

  const inputName = (e) => {
    setName(e.target.value);
    setIsCheck((prev) => !prev);
  };

  const handleSelectCustomerType = (e) => {
    setSelectCustomerType(e);
    setIsCheck((prev) => !prev);
  };

  const inputTaxNo = (e) => {
    const numberRegex = new RegExp(/^[0-9]{0,13}$/);
    const isValidNumber = numberRegex.test(e.target.value);
    if (isValidNumber) {
      setTaxNo(e.target.value);
      setIsCheck((prev) => !prev);
    }
  };

  const inputAddress = (e) => {
    setAddress(e.target.value);
  };

  const inputContact = (e) => {
    // //console.log("inputContact Corp: ", e.target.value);
    // const numberRegex = new RegExp(/^[0-9]{0,10}$/);
    // const isValidNumber = numberRegex.test(e.target.value);
    // if (isValidNumber) {
    //   setContact(e.target.value);
    // }
    setContact(e.target.value);
    setIsCheck((prev) => !prev);
  };

  const inputPhone = (e) => {
    const numberRegex = new RegExp(/^[0-9]{0,10}$/);
    const isValidNumber = numberRegex.test(e.target.value);
    if (isValidNumber) {
      setPhone(e.target.value);
      setIsCheck((prev) => !prev);
    }
  };

  const inputEmail = (e) => {
    setEmail(e.target.value);
    setIsCheck((prev) => !prev);
    const emailRegex = new RegExp(/[a-z0-9]+@[a-z]+\.[a-z]{2,3}$/);
    const isValidEmail = emailRegex.test(e.target.value);
    if (isValidEmail || e.target.value === '') {
      setErrorValidate('');
    } else {
      setErrorValidate(intl.formatMessage({ id: 'validateEmailSignup', defaultMessage: 'Email Invalid' }));
    }
  };

  useEffect(() => {
    setImageFileDefault(DefaultProfile);
  }, []);

  const showOpenFileDialog = (e) => {
    imageRef.current.click();
  };

  const resizeFile = (file) =>
    new Promise((resolve) => {
      Resizer.imageFileResizer(
        file,
        720,
        720,
        'JPEG',
        70,
        0,
        (uri) => {
          resolve(uri);
        },
        'base64'
      );
    });
  const dataURLtoFile = (dataurl, filename) => {
    const arr = dataurl.split(','),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);

    for (var i = 0; i < bstr.length; i++) {
      u8arr[i] = bstr.charCodeAt(i);
    }
    return new File([u8arr], filename, { type: mime });
  };

  const handleChangePicture = async (event) => {
    event.preventDefault();
    let reader = new FileReader();
    const file = event.target.files[0];

    if (file) {
      if (file.name.match(/\.(jpg|jpeg|png|JPG|PNG|JPEG)$/)) {
        const image = await resizeFile(file);
        reader.onloadend = () => {
          const image = reader.result;
          setPreviewImage(image);
        };
        reader.readAsDataURL(file);

        const fileChange = dataURLtoFile(image, file.name);
        setProfilePic(fileChange);
      }
    }
  };

  const removeDoc = (fileHash, index) => {
    const deletedImages = [...fileListDoc];
    if (index >= 0 && index < deletedImages.length) {
      deletedImages.splice(index, 1);
      setFileListDoc(deletedImages);
    } else {
      console.error('Invalid index provided');
    }
  };

  return (
    <div>
      <div style={{ position: 'relative', display: 'inline-block' }}>
        <Avatar
          size={100}
          sx={{
            width: 160,
            height: 160,
            '& img': {
              borderRadius: '50%',
            },
          }}
          alt='Profile Avatar'
          src={previewImage ? previewImage : imageFileDefault}
        />
        <div
          style={{
            position: 'absolute',
            bottom: 5,
            right: 1,
            width: '30px',
            height: '30px',
            backgroundColor: `${COLORS.Primary}`,
            borderRadius: '70%',
            borderStyle: 'solid',
            borderColor: '#fff',
            borderWidth: 2,
            padding: 2,
            cursor: 'pointer',
          }}
          onClick={showOpenFileDialog}
        >
          <CameraOutlined
            style={{
              color: '#fff',
              marginTop: '4px',
              fontSize: '14px',
            }}
          />
        </div>
      </div>
      <input ref={imageRef} type='file' style={{ display: 'none' }} accept='.jpg, .png, .JPG, .PNG' onChange={handleChangePicture} />

      <Modal open={previewOpen} title={previewTitle} footer={null} onCancel={handleCancel}>
        <img alt='example' style={{ width: '100%' }} src={previewImage} />
      </Modal>
      <div style={{ margin: '11%' }}></div>
      <MyInput
        label={<FormattedMessage id='companyName' defaultMessage='Company Name' />}
        placeholder={intl.formatMessage({ id: 'companyName', defaultMessage: 'Company Name' })}
        isRequired
        className='pb-4'
        value={name}
        onChange={inputName}
      />

      <div className='d-flex align-items-center pb-1'>
        <Typography isBold color={COLORS.Primary} className='pb-1'>
          <FormattedMessage id='labelCustomerType' defaultMessage='Customer Type' />
        </Typography>
        <Typography isBold size='14px' color={COLORS.Error} className='pl-2'>
          *
        </Typography>
      </div>

      <Select
        className='w-100 mb-4 '
        placeholder={intl.formatMessage({ id: 'placeholderCustomer', defaultMessage: 'Select Customer' })}
        style={{ textAlign: 'left' }}
        onSelect={(e) => handleSelectCustomerType(e)}
      >
        {customerType &&
          _.map(customerType, (item, index) => {
            return (
              <Option key={_.get(item, 'customerTypeId')} value={_.get(item, 'customerTypeId')}>
                <div className='py-2'>
                  <Typography color={COLORS.Dark}>{_.get(item, 'customerTypeName')}</Typography>
                </div>
              </Option>
            );
          })}
      </Select>

      <MyInput
        label={<FormattedMessage id='taxNo' defaultMessage='Tax No.' />}
        placeholder={intl.formatMessage({ id: 'taxNo', defaultMessage: 'Tax No.' })}
        isRequired
        className='pb-4'
        value={taxNo}
        onChange={inputTaxNo}
      />

      {/* <div>upload image</div> */}
      <div className='pb-4' style={{ textAlign: 'left' }}>
        <Typography className='pb-2' isBold size='14px' color={COLORS.Primary}>
          <FormattedMessage id='juristicDocument(PP20)' defaultMessage='Juristic Document (PP20)' />
        </Typography>

        {!_.size(fileListDoc) > 0 ? (
          <Upload
            accept={fileTypesImg}
            listType='picture-card'
            fileList={fileListDoc}
            beforeUpload={beforeUpload}
            // beforeUpload={beforeUploadDoc}
            onPreview={handlePreviewDoc}
            onChange={handleChangeDoc}
          >
            {fileListDoc.length >= 8 ? null : uploadButtonDoc}
          </Upload>
        ) : (
          fileListDoc?.map((docUrl, index) => (
            <>
              <div
                class='image-container'
                style={{
                  marginRight: '10px',
                  marginBottom: '10px',
                }}
              >
                <span class='close-icon' onClick={() => removeDoc(docUrl, index)}>
                  <CloseOutlined />
                </span>
                <span>
                  <img key={index} src={_.get(docUrl, 'url')} alt={`Document ${index}`} width={120} height={120} />
                </span>
              </div>
            </>
          ))
        )}

        <Modal open={previewOpenDoc} title={previewTitleDoc} footer={null} onCancel={handleCancelDoc}>
          <img alt='example' style={{ width: '100%' }} src={previewImageDoc} />
        </Modal>
      </div>
      {/* <MyInput
        label="Address"
        placeholder="Address"
        className="pb-4"
        value={address}
        onChange={inputAddress}
      /> */}
      <MyInput
        label={<FormattedMessage id='labelContact' defaultMessage='Contact' />}
        placeholder={intl.formatMessage({ id: 'labelContact', defaultMessage: 'Contact' })}
        isRequired
        className='pb-4'
        value={contact}
        onChange={inputContact}
      />
      <MyInput
        label={<FormattedMessage id='labelPhone' defaultMessage='Phone Number' />}
        placeholder={intl.formatMessage({ id: 'labelPhone', defaultMessage: 'Phone Number' })}
        isRequired
        className='pb-4'
        value={phone}
        onChange={inputPhone}
      />
      <MyInput
        label={<FormattedMessage id='labelEmail' defaultMessage='Email' />}
        placeholder={intl.formatMessage({ id: 'labelEmail', defaultMessage: 'Email' })}
        isRequired
        value={email}
        isError={errorValidate !== '' ? true : false}
        errorMsg={errorValidate}
        onChange={inputEmail}
      />
    </div>
  );
};

export default RegisterForm;
